export function isEuropaParkApp(): boolean {
  const userAgent =
    typeof window !== 'undefined' ? window.navigator.userAgent : null;

  return userAgent && userAgent.indexOf('EuropaParkApp/') !== -1;
}
